module.exports = __webpack_public_path__ + "img/sprout.0c53f12e.svg";